<template>
  <div v-if="profile" class="employee-details">

    <div v-if="!profile.fullName" class="text-center">
      <loading-icon></loading-icon>
    </div>

    <div v-else class="row">
      <div class="col-12">

        <h2>Employee Details</h2>

        <div class="row">
          <div class="col-12">
            <ul>
              <li><span class="key">Your Name:</span><span class="value">{{ profile.fullName }}</span></li>
              <li><span class="key">Mobile Phone:</span><span class="value">{{ profile.mobile }}</span></li>
              <li><span class="key">Date of Birth:</span><span class="value">{{ formatIsoDate(profile.dateOfBirth) }}</span></li>
              <li><span class="key">Driver Email:</span><span class="value">{{ profile.emailAddress }}</span></li>
              <li><span class="key">Home Address:</span><span class="value">{{ profile.homeAddress }}</span></li>
              <li><span class="key">Postcode: </span><span class="value">{{ profile.postcode }}</span></li>
              <li><span class="key">Tax Band:</span><span class="value">{{ profile.incomeTaxBand.ratePercent }}%</span></li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card details">
              <h3>{{ product.scheme_card_main_driver_heading_text }}</h3>
              <ul>
                  <li><span class="key">Name: </span><span class="value">{{ profile.fullName }}</span></li>
                  <li><span class="key">Main Driver: </span><span class="value">{{ employeeIsMainDriver ? 'Yes' : 'No' }}</span></li>
                  <li><span class="key">Driver Email: </span><span class="value">{{ profile.emailAddress }}</span></li>
                  <li><span class="key">Date of Birth: </span><span class="value">{{ formatIsoDate(profile.dateOfBirth) }}</span></li>
                  <li><span class="key">Postcode: </span><span class="value">{{profile.postcode }}</span></li>
                  <li><span class="key">Driving Licence Number: </span><span class="value">{{ profile.driverLicence.licenceNumber }}</span></li>
                  <li>&nbsp;</li>
                  <table class="unstyled">
                    <tbody>
                      <tr>
                        <td>Is the driver a permanent UK resident?</td>
                        <td><span class="font-weight-bold">{{ profile.insuranceQuestions['Is the driver a permanent UK resident'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document?</td>
                        <td><span class="font-weight-bold">{{ profile.insuranceQuestions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS?</td>
                        <td><span class="font-weight-bold">{{ profile.insuranceQuestions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT?</td>
                        <td><span class="font-weight-bold">{{ profile.insuranceQuestions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver received any conviction which has resulted in a driving ban in the last 5 years?</td>
                        <td><span class="font-weight-bold">{{ profile.insuranceQuestions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver had more than 1 FAULT claim in the last 3 years?</td>
                        <td><span class="font-weight-bold">{{ profile.insuranceQuestions['Has the driver had more than 1 FAULT claim in the last 3 years'] }}</span></td>
                      </tr>
                    </tbody>
                  </table>
              </ul>
            </div>
          </div>
        </div>

        <div class="row" v-for="additionalDriver, index in additionalDrivers">
          <div class="col-12">
            <div class="card details">
              <h3>{{ index === 0 ? product.scheme_card_additional_driver_one_heading_text : product.scheme_card_additional_driver_two_heading_text }}</h3>
              <ul>
                  <li><span class="key">Name: </span><span class="value">{{ additionalDriver.first_name }} {{ additionalDriver.last_name }}</span></li>
                  <li><span class="key">Main Driver: </span><span class="value">{{ additionalDriver.main_driver ? 'Yes' : 'No' }}</span></li>
                  <li><span class="key">Driver Email: </span><span class="value">{{ additionalDriver.email }}</span></li>
                  <li><span class="key">Date of Birth: </span><span class="value">{{ formatIsoDate(additionalDriver.date_of_birth) }}</span></li>
                  <li><span class="key">Postcode: </span><span class="value">{{additionalDriver.postcode }}</span></li>
                  <li><span class="key">Driving Licence Number: </span><span class="value">{{ additionalDriver.driving_license }}</span></li>
                  <li>&nbsp;</li>
                  <table class="unstyled">
                    <tbody>
                      <tr>
                        <td>Is the driver a permanent UK resident?</td>
                        <td><span class="font-weight-bold">{{ additionalDriver.insurance_questions['Is the driver a permanent UK resident'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document?</td>
                        <td><span class="font-weight-bold">{{ additionalDriver.insurance_questions['Does the driver hold a full hold a full licence from the UK, EU, EEA, or one of the countries listed within the Insurance Eligibility Criteria document'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS?</td>
                        <td><span class="font-weight-bold">{{ additionalDriver.insurance_questions['Has the driver had more than 2 convictions within the last 3 years within any of the following letters on their licence; CU, LC, MW, PC, SP or TS'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT?</td>
                        <td><span class="font-weight-bold">{{ additionalDriver.insurance_questions['Has the driver had any conviction in the last 5 years with any of the following letters on their licence; AC, BA, CD, DD, DG, DR, IN, MS, TT or UT'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver received any conviction which has resulted in a driving ban in the last 5 years?</td>
                        <td><span class="font-weight-bold">{{ additionalDriver.insurance_questions['Has the driver received any conviction which has resulted in a driving ban in the last 5 years'] }}</span></td>
                      </tr>
                      <tr>
                        <td>Has the driver had more than 1 FAULT claim in the last 3 years?</td>
                        <td><span class="font-weight-bold">{{ additionalDriver.insurance_questions['Has the driver had more than 1 FAULT claim in the last 3 years'] }}</span></td>
                      </tr>
                    </tbody>
                  </table>
              </ul>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="agree mb-0">
              <input type="checkbox" name="disclaimer_1" id="disclaimer_1"
                     v-model="employeeDetails" class="disclaimer_1">
              <label for="disclaimer_1">{{ declaration }}</label>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div v-else class="text-center">
    <loading-icon></loading-icon>
  </div>

</template>

<script>

import LoadingIcon from '@/components/loading-icon';

export default {
  components: {
    LoadingIcon,
  },
  props: ['profile', 'employeeIsMainDriver', 'additionalDrivers', 'product', 'session', 'declaration'],
  data: () => {
    return {
      employeeDetails: null,
    }
  },
  watch: {
    employeeDetails(value) {
      this.$parent.confirmations.employeeDetails = value;
    },
  },
  methods: {
    formatIsoDate(isoDate) {
        let formattedDate = '';

        if (isoDate) {
            formattedDate = new Date(isoDate).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        }

        return formattedDate;
    },
  },
  computed: {

    dateOfBirth() {
      let dob = '';

      if (this.profile.dateOfBirth) {
        dob = new Date(this.profile.dateOfBirth).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
      }

      return dob;
    },

    privateCarMileageReimbursementRate() {
      if (!this.session?.driverProfile?.PCH) {
        return '';
      }
      return this.session.driverProfile.PCH.driverGradeDefinition.businessFuelPolicyName;
    },

    privateCarMileageReimbursementRateUpTo() {
      if (!this.session?.driverProfile?.PCH) {
        return '';
      }
      let fuelRate = '';
      this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
        if (Number(item.upToDistance) <= 10000) {
          fuelRate = (item.fuelRate * 100) + ' ppm';
        }
      });

      return fuelRate;
    },

    privateCarMileageReimbursementRateOver() {
      let maxDistance = 0;
      let maxFuelRate = '';

      if (!this.session?.driverProfile?.PCH) {
        return '';
      }

      this.session.driverProfile.PCH.driverGradeDefinition.businessFuelRates[0].items.forEach((item) => {
        if (Number(item.upToDistance) > 10000 && Number(item.upToDistance) > maxDistance) {
          maxDistance = item.upToDistance;
          maxFuelRate = (item.fuelRate * 100) + ' ppm';
        }
      });
      return maxFuelRate;
    }
  }
};
</script>
